import { useEffect as c, useRef as i, useCallback as p } from "react";
import { addCopilotInstruction as m, addCopilotTool as f, addCopilotContext as h } from "../global-state.js";
function C(e) {
  const n = e.isEnabled ?? !0;
  return c(() => {
    if (n === !1)
      return;
    const r = m(e);
    return () => r();
  }, [n, e.instruction]);
}
function b(e) {
  const n = e.isEnabled ?? !0, r = i(e.handler);
  r.current = e.handler;
  const a = e.handler != null, t = i(e.render);
  t.current = e.render;
  const u = e.render != null;
  return c(() => {
    if (n === !1)
      return;
    const d = f(
      e.type === "client" ? {
        type: e.type,
        name: e.name,
        description: e.description,
        requestSchema: e.requestSchema,
        responseSchema: e.responseSchema,
        handler: (s) => r.current?.(s),
        render: u ? (s) => t.current?.(s) : void 0
      } : {
        type: e.type,
        name: e.name,
        description: e.description,
        requestSchema: e.requestSchema,
        responseSchema: e.responseSchema,
        handler: (s) => r.current?.(s),
        render: u ? (s) => t.current?.(s) : void 0,
        isStreaming: e.isStreaming
      }
    );
    return () => d();
  }, [
    n,
    e.type,
    e.name,
    e.description,
    e.requestSchema,
    e.responseSchema,
    "isStreaming" in e ? e.isStreaming : !1,
    a,
    u
  ]);
}
function y(e) {
  const n = e.isEnabled ?? !0, r = i(e);
  r.current = e;
  const a = p(() => typeof r.current.value == "function" ? r.current.value() : r.current.value, []);
  return c(() => {
    if (n === !1)
      return;
    const t = h({
      description: e.description,
      value: a
    });
    return () => t();
  }, [n, e.description]);
}
export {
  y as useCopilotContext,
  C as useCopilotInstruction,
  b as useCopilotTool
};
